module.exports = __webpack_public_path__ + "static/media/abbe_sad.ddc1c7dc.png";